import React, { useCallback, useState } from 'react';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useResolve } from '../Container';
import { Copy, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Input, Prompt } from './../../ui';
import { boardRename } from './BoardCommands';

export const BoardRenamePopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { board } = args;

    const dispatch = useResolve(CommandDispatcher);
    const [working, setWorking] = useState(false);
    const [value, setValue] = useState(board.label);

    const invalid = !value.trim();

    const onApply = useCallback(async () => {
        if (working) return;
        setWorking(true);
        action(await dispatch(boardRename, [board.id, value]));
    }, [board, value]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onApply();
    }, [invalid, onApply]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Rename Board</Popup.Title>
            <Popup.Content>
                <Copy>
                    Enter a new board name:
                </Copy>
                <Spacer f={2} />
                <Input
                    label="Name"
                    placeholder=""
                    value={value}
                    maxLength={64}
                    autoFocus
                    onChange={setValue}
                />
                <Spacer f={2} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={onApply}>
                    {working ? 'Apply...' : 'Apply'}
                </Button>
                <Button disabled={working} onAction={dismiss}>
                    Cancel
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
